import Text from 'components/Text/Text';
import React from 'react';
import { IItemRestaurantDevice } from 'types';
import AssignCheckbox from './components/AssignCheckbox';
import TerminalsList from './components/TerminalsList';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemRestaurantDevice;
	toggleDeviceAssignedStatus: (deviseId: string, status: boolean) => void;
}

const Item: React.FC<IItem> = ({ data, toggleDeviceAssignedStatus }) => {
	const checkboxHeadingClasses = classNames(style.checkbox, style.row);
	const hardwareIdHeadingClasses = classNames(style.hardwareId, style.row);
	const terminalIdHeadingClasses = classNames(style.terminalId, style.row);
	const tableNumberHeadingClasses = classNames(style.tableNumber, style.row);

	return (
		<div>
			<div className={style.container}>
				<div className={checkboxHeadingClasses}>
					<AssignCheckbox data={data} toggleDeviceAssignedStatus={toggleDeviceAssignedStatus} />
				</div>
				<Text className={hardwareIdHeadingClasses} translationKey={data.hardwareId} withTooltip={true} />
				<div className={terminalIdHeadingClasses}>
					<TerminalsList data={data.terminalIds} />
				</div>
				<Text className={tableNumberHeadingClasses} translationKey={data.tableName} withTooltip={true} />
			</div>
		</div>
	);
};

export default React.memo(Item);
